
/**
 * ค่าใช้จ่ายประจำรถ — header (truck_fix_cost) + items (truck_fix_cost_item).
 *
 * Only columns that do NOT already exist in a shared constant live here. TukId / TlrId
 * come from truckConstant + trailerConstant, SupId from the supplier combo.
 *
 * The document types are DATA (`truck_fix_cost_type`), loaded from
 * /truck-fix-cost/getTruckFixCostType. There is deliberately no hardcoded list — a branch
 * can add its own types and a copy here would drift.
 */
export const truckFixCostColNm = {
  TukFixCostId: "รหัสเอกสาร",
  TukFixCostTypId: "ประเภทเอกสาร",
  TukFixCostTypNm: "ประเภทเอกสาร",
  StrDte: "วันเริ่มต้น",
  EndDte: "วันสิ้นสุด",
  Amnt: "ยอดรวมทั้งเอกสาร",
  NumPrd: "จำนวนงวด",
  PrdAmnt: "ค่างวด/งวด",
  IntAmnt: "ดอกเบี้ย",
  MonthAmnt: "เฉลี่ย/เดือน",
  DayLeft: "เหลือ (วัน)",
  DocNo: "เลขที่เอกสาร (ทั้งใบ)",
  PayDte: "วันที่จ่าย",
  IsActv: "Active",
  Rmk: "หมายเหตุ",
  CoAId: "ผังบัญชี",
  NumVeh: "จำนวนคัน",
  VehNms: "รถ/หางพ่วง",
  ItmAmnt: "รวมยอดแยกคัน",
  ItemAmnt: "ยอดของคันนี้",
  // The vehicle's OWN number — a batch of 26 trucks has one receipt number on the
  // header and 26 ป้ายวงกลม/พ.ร.บ. เลขที่ down here. Empty for a shared policy.
  ItemDocNo: "เลขที่เอกสาร (คันนี้)",
}

/**
 * ค่าผ่อนงวดรถ — the one seeded type the dialog treats specially (งวด fields + the
 * interest split). Mirrors TYP_INSTALLMENT in module/constant/truckFixCostTyp.js;
 * ids 1-6 are seeded fixed on every branch by the migration.
 */
export const TYP_INSTALLMENT = 5
